import React from 'react'
import { Modal, Button } from 'react-bootstrap'

import { resultsPdfPrintCompact } from '../../../utils/pdf.js'
import { resultsPdfPrintExtended } from '../../../utils/pdf.js'
import {ScanResultContext} from '../../../context/ScanResultContext'

export default class ResultsPdfModal extends React.Component {
  constructor(props, context) {
    super(props, context)
    this.handleShow = this.handleShow.bind(this)
    this.handleHide = this.handleHide.bind(this)
    this.downloadCompact = this.downloadCompact.bind(this)
    this.downloadExtended = this.downloadExtended.bind(this)
    this.resultsPdfPrintCompact = resultsPdfPrintCompact.bind(this)
    this.resultsPdfPrintExtended = resultsPdfPrintExtended.bind(this)

    this.state = {show: false}
  }

  downloadCompact() {
    this.resultsPdfPrintCompact()
    this.handleHide()
  }

  downloadExtended() {
    setTimeout(function() {
      resultsPdfPrintExtended()
    }, 1000)
    this.handleHide()
  }

  handleHide() {
    this.setState({ show: false })
  }

  handleShow() {
    this.setState({ show: true })
  }

  render() {
    return (
      <ScanResultContext.Consumer>
        {context => (
          <div>
            <Button bsStyle="primary" onClick={this.handleShow}>
              {this.props.textbtn}
            </Button>
            <Modal
              {...this.props}
              show={this.state.show}
              onHide={this.handleHide}
              dialogClassName="custom-modal"
              backdrop={false}>
              <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-lg">
                  {this.props.title}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div dangerouslySetInnerHTML={{ __html: this.props.text }}></div>
              </Modal.Body>
              <Modal.Footer>
                { /* BW-171 Temporary disabled
                <Button bsStyle="primary" onClick={this.downloadCompact}>Compact (PDF)</Button> */ }
                <Button bsStyle="primary" onClick={(e) => {
                  context.showPrintView()
                  this.downloadExtended()
                  setTimeout(function() {
                    context.hidePrintView()
                  }, 3000)
                }}>
                  Uitgebreid (PDF)
                </Button>
                <Button onClick={this.handleHide}>Annuleren</Button>
              </Modal.Footer>
            </Modal>
          </div>
        )}
      </ScanResultContext.Consumer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/pages/Results/modal/ResultsPdfModal.js